import { ContactSurSiteFormState } from '@/models/ContactSurSiteForm';
import { Delai } from '@/models/Delai';
import { DemandeInterventionContact } from '@/models/DemandeInterventionContact';
import { EquipementItems } from '@/models/EquipementItems';
import { EtatEquipement } from '@/models/EtatEquipement';
import { Site } from '@/models/Site';
import { TypeItems } from '@/models/TypeItems';
import { RootState } from '@/plugins/store';
import dayjs from 'dayjs';
import { GetterTree } from 'vuex';
import { DemandeInterventionState } from './state';
import Regex from '@/common/utils/Regex';

export const getters: GetterTree<DemandeInterventionState, RootState> = {
    getInterventionStep(state): number {
        return state.step;
    },
    getInterventionSiteValue(state): Site | undefined {
        return state.site;
    },
    getInterventionTypeValue(state): TypeItems | undefined {
        return state.type;
    },
    getInterventionDelaiValue(state): Delai | undefined {
        return state.delai;
    },
    getInterventionDateAutreValue(state): string | undefined {
        return state.dateAutre;
    },
    getInterventionEquipementValue(state): EquipementItems | undefined | null {
        return state.equipement;
    },
    getInterventionEquipementConditionValue(state): EtatEquipement | undefined {
        return state.etatEquipement;
    },
    getInterventionObjetValue(state): string {
        return state.objet;
    },
    getInterventionDescriptifValue(state): string {
        return state.descriptif;
    },
    getInterventionFiles(state): File[] {
        return state.documents;
    },
    getInterventionSuiviValue(state): boolean {
        return state.suivi;
    },
    getInterventionRecurrenteValue(state): boolean {
        return state.recurrente;
    },
    getInterventionContactSurSiteValue(state): ContactSurSiteFormState | undefined {
        return state.contactSurSite;
    },
    getInterventionContactsValue(state): DemandeInterventionContact[] {
        return state.contacts;
    },
    getInterventionContactSurSiteListValue(state): ContactSurSiteFormState[] {
        return state.listeContactSurSite;
    },
    getInterventionContactsListValue(state): DemandeInterventionContact[] {
        return state.listeContacts;
    },
    getInterventionAskInterventionData(state): DemandeInterventionState {
        return state;
    },
    getIntervenTionRequestSuccess(state): boolean {
        return state.success;
    },
    getInterventionLoading(state): boolean {
        return state.isLoading;
    },
    getInterventionResponse(state): unknown {
        return state.response;
    },
    isInterventionFormValid(state): boolean {
        const reg = Regex.telephone();
        switch (state.step) {
            case 1:
                return state.site !== undefined;
            case 2:
                return (
                    state.type !== undefined &&
                    state.delai !== undefined &&
                    (!state.delai?.isAutre || dayjs(state.dateAutre).isValid())
                );
            case 3:
                return (
                    state.equipement !== undefined && (state.equipement === null || state.etatEquipement !== undefined)
                );
            case 4:
                return state.objet.trim() !== '';
            case 5:
                return (
                    state.contactSurSite?.firstname !== '' &&
                    state.contactSurSite?.lastname !== '' &&
                    (reg.test(state.contactSurSite?.telephoneMobile ?? '') || reg.test(state.contactSurSite?.telephoneFixe ?? '')) &&
                    !(state.suivi && state.contacts.length === 0)
                );
            case 6:
                return true;
            default:
                return false;
        }
    },
    isHeureAstreinte(state): boolean {
        return state.isHeureAstreinte;
    },
    isJourFerie(state): boolean {
        return state.isJourFerie;
    },
    getCoordonneesAstreinte(state) {
        return state.coordonneesAstreinte;
    },
    getCoordonneesJourFerie(state) {
        return state.coordonneesJourFerie;
    },
};
